export enum PaymentMethod {
  Cash = 0,
  PaymentCard = 1,
}
